export const GET_PAYMENT_ATTEMPT = 'GET_PAYMENT_ATTEMPT';
export type GET_PAYMENT_ATTEMPT = typeof GET_PAYMENT_ATTEMPT;

export const GET_PAYMENT_SUCCESS = 'GET_PAYMENT_SUCCESS';
export type GET_PAYMENT_SUCCESS = typeof GET_PAYMENT_SUCCESS;

export const GET_PAYMENT_FAILURE = 'GET_PAYMENT_FAILURE';
export type GET_PAYMENT_FAILURE = typeof GET_PAYMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/payment/get/Types.tsx